import React from "react";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-us pt-4 pb-4">
      <div className="container">
        <h2 className="text-center">
          Get in touch with us <br />
          for any queries
        </h2>
        <h6 className="text-center">
          Leave us your email address and we will contact you
        </h6>
        <div className="email-form d-flex d-block mx-auto">
          <input
            type="email"
            className="form-control me-1"
            id="exampleFormControlInput1"
            placeholder="name@example.com"
          />

          <button className="btn btn-custom">Submit</button>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
